export default "__VITE_ASSET__VWupbmij__"